import { Recorder } from '@ftr/contracts/api/recorder'
import { RecordingType } from '@ftr/contracts/type/recording'
import { generateUuid } from '@ftr/contracts/type/shared'
import { AbstractBuilder } from '@ftr/foundation'

let recorderCounter = 1

export class RecorderBuilder extends AbstractBuilder<Recorder> {
  constructor() {
    super({
      id: generateUuid(),
      name: `Recorder ${recorderCounter++}`,
      courtSystemId: generateUuid(),
      locationId: generateUuid(),
      type: RecordingType.TRM,
    })
  }
}
